import config from "../config";

// POST /_/heartbeat to mint or refresh the apex vc_last_activity cookie.
// The CloudFront Function vc-session-edge intercepts this on viewer-request
// and returns 204 with a fresh signed cookie (or 401 if the session is dead).
//
// Returns true on success, false on 401 (session expired at edge).
// Network/other errors are fail-open (returns true) — a transient failure
// must not force a logout, the next heartbeat will re-check.
export async function sendHeartbeat() {
  if (!isEdgeSessionEnabled()) return true;
  try {
    const res = await fetch(config.sessionEdge.heartbeatPath, {
      method: "POST",
      credentials: "include",
      cache: "no-store",
    });
    if (res.status === 401) {
      console.warn(
        "[session-edge] heartbeat returned 401 — session expired at edge"
      );
      return false;
    }
    return true;
  } catch (err) {
    console.warn("[session-edge] heartbeat failed:", err);
    return true;
  }
}

// Parse vc_last_activity and return the activity timestamp in milliseconds,
// or null if the cookie is absent or malformed. Format: {unix_seconds}.{hmac}.
// The edge function verifies the HMAC on every request; this client-side
// read trusts the timestamp because a tampered cookie would be rejected
// by the edge on the next navigation anyway.
export function readSessionExpiry() {
  if (!isEdgeSessionEnabled()) return null;
  const prefix = `${config.sessionEdge.cookieName}=`;
  const cookie = document.cookie
    .split(";")
    .map((c) => c.trim())
    .find((c) => c.startsWith(prefix));
  if (!cookie) return null;

  const value = cookie.slice(prefix.length);
  const dot = value.indexOf(".");
  if (dot <= 0) return null;

  const seconds = Number(value.slice(0, dot));
  if (!Number.isFinite(seconds) || seconds <= 0) return null;

  return seconds * 1000;
}

export function isEdgeSessionEnabled() {
  return Boolean(config.sessionEdge && config.sessionEdge.enabled);
}
